"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayBufferTo64 = void 0;
exports.arrayBufferTo64 = (a) => {
    const b = new Uint8Array(a);
    return btoa(b.reduce((data, byte) => data + String.fromCharCode(byte), ""));
};
